import React, { useState } from 'react'
import EditSavings from './EditSavings'
import { getAmount } from '../../Services/util-functions'
import Button from '../Design/Button'

const Savings = props => {
  const [edit, setEdit] = useState(false)
  const [title, setTitle] = useState('Savings')

  const handleEdit = (newEdit, newTitle) => {
    setEdit(newEdit)
    setTitle(newTitle)
  }

  const handleNewSavings = newSavings => {
    setEdit(false)
    setTitle('Savings')
    props.newSavings(newSavings)
  }

  const savingsDispaly = (
    <div>
      <p>{getAmount(props.savings.amount)}</p>
      <Button addClass='edit-button' clicked={() => handleEdit(true, 'Edit Savings')} text='Edit Savings' />
    </div>
  )
  return (
    <div className='account-overview-card fade-in'>
      <h2>{title}</h2>
      <div className='account-overview-card-content'>
        {
          edit
            ? <EditSavings savings={props.savings} onHandleNewSavings={handleNewSavings} onHandleEdit={handleEdit} />
            : savingsDispaly
        }
      </div>
    </div>
  )
}

export default Savings
